import { UserRoleEnum } from '~enums';

import useSession from './useSession';

/**
 * useAuthorize — internal auth helper.
 * AdminInternal bypasses all checks.
 *
 * @returns Object with:
 * - authorize: (roles: UserRoleEnum[]) => boolean
 * - authorizeForOrganization: (organisationId: string) => boolean
 */
const useAuthorize = () => {
	const { user } = useSession();
	const role = user?.role;

	const authorize = (roles: UserRoleEnum[]) => {
		if (roles == undefined) {
			return false;
		}

		// If route allows anonymous, it's authorized regardless of role
		if (roles.includes(UserRoleEnum.AllowAnonymous)) {
			return true;
		}

		if (!role) {
			// Role not yet loaded; defer decision to route (treated as loading there)
			return false;
		}

		return roles.includes(role);
	};

	const authorizeForOrganisation = (organisationId: string) => {
		return user?.organisationId?.includes(organisationId) || role === UserRoleEnum.SuperAdmin;
	};

	return {
		authorize,
		authorizeForOrganisation,
		hasRole: Boolean(role),
	};
};

export default useAuthorize;
